
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import type { ImportDataType } from "../types";

interface ImportResultsProps {
  results: {
    success: number;
    errors: number;
    errorMessages: string[];
  };
  onReset: () => void;
  dataType: ImportDataType;
}

export function ImportResults({ results, onReset, dataType }: ImportResultsProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">Import Results</h3>
      
      {results.success > 0 && (
        <Alert className="bg-green-50 border-green-200">
          <AlertTitle className="text-green-800">Success</AlertTitle>
          <AlertDescription className="text-green-700">
            Successfully imported {results.success} {dataType}
          </AlertDescription>
        </Alert>
      )}
      
      {results.errors > 0 && (
        <Alert variant="destructive">
          <AlertTitle>Errors</AlertTitle>
          <AlertDescription>
            Failed to import {results.errors} records
            <ul className="mt-2 list-disc pl-5">
              {results.errorMessages.map((msg, i) => (
                <li key={i}>{msg}</li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}
      
      <div className="flex justify-between pt-4">
        <Button onClick={onReset}>
          Import More {dataType}
        </Button>
      </div>
    </div>
  );
}
